import React from 'react';
import { Loader2, RotateCw } from 'lucide-react';
import { PICK_RESULT_CLASS, legLabel } from '../lib/hostedBets';
import { formatMoney } from '../lib/formatters';

// Sistem kuponunun künyesi. Sıradan kombineden iki noktada ayrılır ve
// ikisi de para ile ilgilidir: bahis **kombinasyon başına** konur (kuponun
// tutarı birim bahis × kombinasyon sayısıdır) ve bir bacağın kaybetmesi
// kuponu bitirmez — kalan kombinasyonlar ödenir. Yazılmazsa yönetici
// "4 maçlık kombine neden 11 kez ödendi" sorusunu yanıtlayamaz.
const SystemBadge = ({ system }) => {
  if (!system) return null;
  const parts = [];
  if (system.name) parts.push(system.name);
  else if (system.size > 0) parts.push(`${system.size}'li kombinasyon`);
  if (system.combinations > 0) parts.push(`${system.combinations} kombinasyon`);
  if (system.unit_stake > 0) {
    parts.push(`birim ${formatMoney(system.unit_stake)}`);
  }
  if (!parts.length) return null;
  return (
    <div className="mb-1 text-[10px] font-semibold uppercase tracking-wide text-amber-300">
      Sistem · {parts.join(' · ')}
    </div>
  );
};

// Hazır spor kitabı kuponunun bacakları — "üye hangi maça oynamış".
//
// Bileşen yalnızca çizer; içeriği ``useHostedBetDetails`` doldurur (kuponun
// içi para hareketiyle gelmez, sağlayıcıdan ayrıca istenir). Eksik satır
// "getiriliyor" der, hata alan satır elle yeniden denenir — hatayı sessizce
// boş bir hücreye çevirmek yöneticiyi "bu üye ne oynamış" sorusuyla baş başa
// bırakırdı.

const HostedBetSelections = ({ item, loading = false, error = '', onRetry }) => {
  const legs = item.selections || [];

  if (legs.length) {
    return (
      <div className="space-y-1">
        <SystemBadge system={item.system} />
        {legs.map((leg, index) => (
          <div key={index} className="flex flex-wrap items-center gap-2 text-xs">
            <span className="font-semibold text-white">
              {leg.event || 'Maç bilgisi yok'}
            </span>
            {legLabel(leg) && (
              <span className={PICK_RESULT_CLASS[leg.result] || 'text-slate-300'}>
                {legLabel(leg)}
              </span>
            )}
            {Number(leg.odds) > 0 && (
              <span className="font-bold text-slate-200">
                {Number(leg.odds).toFixed(2)}
              </span>
            )}
            {leg.score && <span className="text-slate-500">({leg.score})</span>}
            {leg.league && (
              <span className="text-[10px] text-slate-600">{leg.league}</span>
            )}
          </div>
        ))}
      </div>
    );
  }

  if (loading) {
    return (
      <span className="inline-flex items-center gap-2 text-[11px] text-slate-500">
        <Loader2 size={12} className="animate-spin" /> İçerik getiriliyor…
      </span>
    );
  }

  if (error) {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-[10px] text-rose-400">{error}</span>
        {onRetry && (
          <button
            type="button"
            onClick={() => onRetry(item)}
            className="admin-btn-secondary inline-flex w-fit items-center gap-2 !py-1 !text-[11px]"
          >
            <RotateCw size={12} /> Tekrar dene
          </button>
        )}
      </div>
    );
  }

  if (item.detail_unparsed && item.detail) {
    // Gövde geldi ama maç içermiyor ya da tanınmadı (Viper yalnızca kupon
    // özetini verir). Uydurma bir eşleme yazılmaz; ham metin **katlı** durur
    // — açık basıldığında her satır kod bloğuna dönüyor ve liste
    // okunmuyordu, teşhis için ise bir tık yeter.
    return (
      <details className="text-[11px] text-slate-500">
        <summary className="cursor-pointer select-none">
          Maç bilgisi sağlayıcıdan gelmedi · ham gövde
        </summary>
        <pre className="mt-1 max-h-32 max-w-[420px] overflow-auto whitespace-pre-wrap break-all rounded-md bg-black/30 p-2 text-[10px] text-slate-400">
          {typeof item.detail === 'string'
            ? item.detail
            : JSON.stringify(item.detail, null, 1)}
        </pre>
      </details>
    );
  }

  return (
    <span className="text-[11px] text-slate-600">
      Sağlayıcı bu kuponun içeriğini vermedi
    </span>
  );
};

export default HostedBetSelections;
